import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { applyTheme, readTheme } from "./lib/theme";
import { ForgotPassword, ResetPassword, SignIn, SignUp, VerifyEmail } from "./pages/auth";
import { InvitePage } from "./pages/invite";
import { Profile } from "./pages/profile";
import { ProjectPage } from "./pages/projects";
import { WorkPage } from "./pages/work";
import { TasksPage } from "./pages/tasks";
import { HelpPage } from "./pages/help";
import { RoomView } from "./pages/room";
import { Settings } from "./pages/settings";
import { AppShell, HomeRedirect } from "./pages/shell";
import "./styles/app.css";
import { UsagePage } from "./pages/usage";
// The office loads three.js, so it comes in only when opened.
const OfficePage = lazy(() => import("./pages/office"));

applyTheme(readTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<HomeRedirect />} />
          <Route path="r/:roomId" element={<RoomView />} />
          <Route path="settings" element={<Settings />} />
          <Route path="settings/usage" element={<UsagePage />} />
          <Route
            path="office"
            element={
              <Suspense fallback={<div className="loading" aria-busy="true" />}>
                <OfficePage />
              </Suspense>
            }
          />
          <Route path="profile" element={<Profile />} />
          <Route path="p/:projectId" element={<ProjectPage />} />
          <Route path="tasks" element={<TasksPage />} />
          <Route path="work/:sessionId" element={<WorkPage />} />
          <Route path="help" element={<HelpPage />} />
        </Route>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/invite" element={<InvitePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
